import React from 'react';
import { useSelector } from 'react-redux';
import AdminDashboard from '../components/AdminDashboard';
import UserDashboard from '../components/UserDashboard';

const DashboardScreen = ({ history }) => {
  const { loading, error, userInfo } = useSelector((state) => state.user);

  return (
    <>
      <UserDashboard history={history} />
      {!error && !loading && userInfo.isAdmin && <AdminDashboard />}
    </>
  );
};

export default DashboardScreen;
